import { render, staticRenderFns } from "./CreateBuildingLog.vue?vue&type=template&id=59530e36&lang=pug&"
import script from "./CreateBuildingLog.vue?vue&type=script&lang=ts&"
export * from "./CreateBuildingLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports